const footer = {
  footer: {
    imageTitle: 'Bezoek de website van Enphase Energy',
    privacy: 'Privacy',
    terms: 'Voorwaarden',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. Alle rechten voorbehouden.',
    language: 'Taal',
    production_ct: {
      verify_ct: "CT controleren",
      checlist_nodata: "Onvoldoende metergegevens beschikbaar om deze controle uit te voeren",
      production_meter_verification: "Verificatie van de productiemeter",
      serial_no: "Serienr.",
      polarity_check: "Polariteitscontrole",
      polarity_check_failed: "Polariteitscontrole mislukt",     
      ct_missing_branch_check: "Controleren of CT ontbrekende aftakkingen heeft",
      polarity_check_passed: "Polariteitscontrole geslaagd",
      ct_no_missing_branch_circuit: "CT heeft geen ontbrekende aftakkingen",
      incorrect_direction_or_phase_message: "De richting of fase van de productie-CT kan onjuist zijn",
      hide_details: "Details verbergen",
      check_try_again: "Controleer het volgende en probeer het opnieuw",
      pv_on_for_5_min: "Zorg ervoor dat het PV-circuit is ingeschakeld en ten minste 5 minuten heeft gewerkt.",
      l1_wires_production_ct_message: "Controleer of alleen L1-draden door de productie-CT gaan en de productiestroom in de richting van de CT-pijl van PV naar breker gaat.",
      blue_white_wires_position_message: "Zorg ervoor dat de blauwe en witte draden op de juiste posities in het Gateway-aansluitblok zijn aangesloten",
      wires_include_pv_generation_not_load_storage: "Zorg ervoor dat de draden die door de productie-CT lopen alleen PV-opwekking omvatten (geen belastingen of opslag).",
      l1_a_correct_phase_message: "Zorg ervoor dat de juiste fase, d.w.z. L1(a), door de productie-CT gaat.",
      l1_phase_consistency_check_message: "Controleer met een digitale meter de faseovereenstemming van L1 en zorg ervoor dat L1 van PV-circuits en L1 bij Gateway in dezelfde fase zitten.",
      missing_branch_warning: "Productie CT kan ontbrekende aftakkingen hebben",
      test_only_valid_for_sunshine_hours: "Deze test is alleen geldig voor zonuren",
      reading_lower_than_expected: "De productiemetingen zijn lager dan verwacht. Controleer het volgende, tik en probeer het opnieuw",
      wires_include_all_pv_generation: "Zorg ervoor dat de draad die door de productie-CT loopt, alle PV-generatiecircuits omvat.",
      branch_circuit_reverse_check: "Zorg ervoor dat geen van de aftakkingen in omgekeerde richting door de CT gaat.",
      storage_load_circuits_through_production_ct: "Zorg ervoor dat er opslag- of belastingscircuits door de productie-CT lopen.",
      show_details: "Details weergeven",
      verify_ct_not_supported_for_device: "geverifieerde CT wordt niet ondersteund door dit apparaat",
      verify_ct_timeStamp: "Gecontroleerd",
      verify_ct_systemID: "systeem-id",
      prodct_reversepolarity_text: "De richting of fase van de productie-CT kan onjuist zijn",
      prodct_reverse_polarity_btn: "Omgekeerde polariteit",
      verify_ct_timeout: "Het verzoek is verlopen. Probeer het opnieuw"

    }
  }
};

export default footer;
